import { useEffect } from "react";
import { Outlet } from "react-router";
import biApi from "../../../../../../../api/biApi";
import useClientContext from "../../../../../../../context/useClientContext.ts";
import { GroupsContextProvider } from "../../../../report-lists/groups/contexts/GroupsContextProvider.tsx";
import {
  getApiReportsUrl,
  getEditApiReportUrl,
  getViewApiReportUrl,
} from "../../../../report-lists/reports/utilities/editReportUrl.ts";
import type { BiApiClient } from "../../../contexts/ApiClientProviderContext";
import { BiApiClientProvider } from "../../../contexts/BiApiClientProvider.tsx";
import useReportMode from "../../../hooks/useReportMode";
import { useAppDispatch } from "../../../store/hooks/useAppDispatch";
import { fieldsStateActions } from "../../../store/thunks/fieldStatesThunks";
import useReportGroups from "../common/hooks/useReportGroups";

const ReportsContainer = () => {
  const { mode } = useReportMode();
  const dispatch = useAppDispatch();
  const { clientCode } = useClientContext();
  const { reportGroups, actions, ui } = useReportGroups({ apiClient: biApi.apiReports });

  useEffect(() => {
    if (mode === "view") {
      //The mode can be changed from edit to run, so we need to reset the fields state
      dispatch(fieldsStateActions.resetFieldsState());
    }
  }, [mode, dispatch]);

  return (
    <BiApiClientProvider<BiApiClient>
      api={{
        updateReport: biApi.apiReports.updateReport,
        addReport: biApi.apiReports.addReport,
        createDraftReport: biApi.apiReports.createDraftReport,
        getReport: biApi.apiReports.getReport,
        runTabularReport: biApi.apiReports.runTabularReport,
        buildTabularReport: biApi.apiReports.buildTabularReport,
        renameReport: biApi.apiReports.renameReport,
        changeReportGroup: biApi.apiReports.changeReportGroup,
        deleteReports: biApi.apiReports.deleteReports,
        getReportAuthorizationInfo: biApi.apiReports.getReportAuthorizationInfo,
        getReports: biApi.apiReports.getReports,
        getReportConfigurationForRunning: biApi.apiReports.getReportConfigurationForRunning,
        validateName: biApi.apiReports.validateReportName,
        getReportSharing: biApi.apiReports.getReportSharing,
        updateReportSharing: biApi.apiReports.updateReportSharing,
        getEditReportUrl: getEditApiReportUrl,
        getViewReportUrl: getViewApiReportUrl,
        getReportsUrl: getApiReportsUrl,
        requestRunTabularExport: biApi.apiReports.requestRunTabularExport,
        requestBuildTabularExport: biApi.apiReports.requestBuildTabularExport,
        getReportHistory: biApi.apiReports.getReportHistory,
      }}
    >
      <GroupsContextProvider groups={{ [clientCode]: reportGroups }} ui={ui} actions={actions}>
        <Outlet />
      </GroupsContextProvider>
    </BiApiClientProvider>
  );
};

export default ReportsContainer;
